import { Badge } from '@/components/ui'
import type { WorkflowNodeStatus } from '@/types'
import { cn } from '@/lib/utils'

const statusConfig: Record<WorkflowNodeStatus, { label: string; className: string }> = {
  Pending: { label: 'Pending', className: 'bg-neutral text-neutral-foreground border-neutral-foreground' },
  Ready: { label: 'Ready', className: 'bg-neutral text-neutral-foreground border-neutral-foreground' },
  Running: { label: 'Running', className: 'bg-info text-info-foreground border-info-foreground animate-pulse' },
  RetryPending: { label: 'Retrying...', className: 'bg-purple text-purple-foreground border-purple-foreground animate-pulse' },
  AwaitingUserInput: { label: 'Awaiting Input', className: 'bg-warning text-warning-foreground border-warning-foreground animate-pulse' },
  Completed: { label: 'Completed', className: 'bg-success text-success-foreground border-success-foreground' },
  Failed: { label: 'Failed', className: 'bg-danger text-danger-foreground border border-danger-foreground' },
  Skipped: { label: 'Skipped', className: 'bg-neutral text-neutral-foreground border-neutral-foreground' },
}

export function NodeStatusBadge({ status, className }: { status: WorkflowNodeStatus; className?: string }) {
  const config = statusConfig[status]
  return (
    <Badge variant="outline" className={cn(config.className, className)} data-testid="node-status-badge">
      {config.label}
    </Badge>
  )
}
